import actions from './actions'
import mutations from './mutations'

const DEFAULT_STATE = {
  interface: null,
  // the current id of the request sent to the servers, this is needed to ensure that we do not get a previously requested content last
  // the most recent request should match this number
  requestNumber: 0,
  viewingSource: 'aalive3',  // I believe this will be the default value no matter what
  metrics: null,
  audienceSize: null,
  hisoricalViewership: null,
  universe: null,
  selectedDayPartNetworks: [], // the selected networks that the user has selected from the Network button on the viewership graph
  // the default values for the networks
  selectedViewershipNetworks: ["ADSM", "HLN", "CNN", "TNT", "TRU", "TBSC", "TOON", "BOOM", "NBAT"], // the selected Viewership networks. This is different than the day parts.
  // the day parts networks are defined by the viewershipNetworks, but independent day parts can be extracted at will
  // I can remove day parts networks, I can only set the viewership networks wich will set the day parts networks
  loading: false,
  // sets the values selectable in the AudienceSize component's ViewershipTimeFrame component
  // this affects the viewing stream of the target
  validStreamingOptions: ['C3']
}

const state = function () {
  return {
    ...DEFAULT_STATE
  }
}

const getters = {
  viewingStream (state) {
    return state.viewingSource
  }
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module
export {DEFAULT_STATE as LAS_DEFAULT_STATE}



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/LAS/store/index.js